import { render, staticRenderFns } from "./MasterComponent.vue?vue&type=template&id=68ab2e8e&scoped=true"
import script from "./MasterComponent.vue?vue&type=script&lang=js"
export * from "./MasterComponent.vue?vue&type=script&lang=js"
import style0 from "./MasterComponent.vue?vue&type=style&index=0&id=68ab2e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab2e8e",
  null
  
)

export default component.exports